<template>
    <v-app id="pciz-database">
        <v-app-bar
                app
                color="blue darken-3"
                dark
        >
            <v-toolbar-title
                    style="width: 300px"
                    class="ml-0 pl-4"
            >
                <span class="hidden-sm-and-down">PCI-Z Database</span>
            </v-toolbar-title>
            <v-spacer/>
        </v-app-bar>
        <v-content>
            <v-container fluid>
                <v-tabs fixed-tabs>
                    <v-tab>Systems</v-tab>
                    <v-tab-item>
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-title>
                                        Systems
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                                v-model="searchSystems"
                                                append-icon="mdi-magnify"
                                                label="Search motherboard"
                                                single-line
                                                hide-details
                                        ></v-text-field>
                                    </v-card-title>
                                    <v-data-table
                                            :headers="headersSystem"
                                            :items="systems"
                                            :loading="dataSystemTablesLoading"
                                            loading-text="Loading..."
                                            @click:row="rowClickSystem"
                                            single-select
                                            :search="searchSystems"
                                            :footer-props=" {
                                                'items-per-page-options': [5, 10, 15]
                                            }"
                                            :items-per-page="5"
                                            item-key="id"
                                    />
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-title>
                                        Devices
                                    </v-card-title>
                                    <v-data-table
                                            :headers="headersDevices"
                                            :items="devices"
                                            :items-per-page="10"
                                            :loading="dataDevicesTablesLoading"
                                            loading-text="Loading..."
                                            single-select
                                    />
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab>Devices</v-tab>
                    <v-tab-item>
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-title>
                                        Devices
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                                v-model="searchDevices"
                                                append-icon="mdi-magnify"
                                                label="Search device"
                                                single-line
                                                hide-details
                                        ></v-text-field>
                                    </v-card-title>
                                    <v-data-table
                                            :headers="headersDevices"
                                            :items="allDevices"
                                            :loading="dataDevicesTablesLoading"
                                            :search="searchDevices"
                                            loading-text="Loading..."
                                            single-select
                                            :footer-props=" {
                                                'items-per-page-options': [5, 10, 15]
                                            }"
                                            :items-per-page="5"
                                            @click:row="rowClickDevice"
                                            item-key="full_pci"
                                    />
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-title>
                                        Systems
                                    </v-card-title>
                                    <v-data-table
                                            :headers="headersSystem"
                                            :items="allSystems"
                                            :loading="dataAllSystemsTablesLoading"
                                            loading-text="Loading..."
                                            single-select
                                            :footer-props=" {
                                                'items-per-page-options': [5, 10, 15]
                                            }"
                                            :items-per-page="5"
                                    />
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs>
            </v-container>
        </v-content>
    </v-app>
</template>
<style scoped>
    /deep/ tr.v-data-table__selected {
        background: rgba(24, 103, 192, 0.3) !important;
    }
</style>
<script>
    export default {
        methods: {
            rowClickSystem: function (item, row) {
                this.devices = [{}];
                this.dataDevicesTablesLoading = true;
                row.select(true);
                this.$http.post('https://www.pci-z.com/db/getDevicesSystem.php', {id: row.item.id}, {emulateJSON: true}).then(response => {
                    this.devices = response.body;
                    this.dataDevicesTablesLoading = false;
                }, response => {
                    console.log(response);
                    this.dataDevicesTablesLoading = false;
                });
            },
            rowClickDevice: function (item, row) {
                this.allSystems = [{}];
                this.dataAllSystemsTablesLoading = true;
                row.select(true);
                this.$http.post('https://www.pci-z.com/db/getSystemsDevice.php', {id: row.item.full_pci}, {emulateJSON: true}).then(response => {
                    this.allSystems = response.body;
                    this.dataAllSystemsTablesLoading = false;
                }, response => {
                    console.log(response);
                    this.dataAllSystemsTablesLoading = false;
                });
            }
        },
        data: () => ({
            dataSystemTablesLoading: true,
            dataDevicesTablesLoading: false,
            dataAllDevicesTablesLoading: true,
            dataAllSystemsTablesLoading: false,
            searchSystems: '',
            searchDevices: '',
            headersSystem: [
                {
                    text: 'Vendor',
                    sortable: true,
                    value: 'mbo_vendor',
                    filterable: false,
                },
                {
                    text: 'Model',
                    sortable: true,
                    value: 'mbo_name',
                    filterable: true,
                },
                {
                    text: 'BIOS version',
                    sortable: false,
                    value: 'mbo_bios',
                    filterable: false,
                },
                {
                    text: 'CPU',
                    value: 'cpu',
                    filterable: false,
                },
                {
                    text: 'OS',
                    value: 'winver',
                    filterable: false,
                },
            ],
            headersDevices: [
                {
                    text: 'Vendor',
                    value: 'real_vendor',
                    filterable: false,
                },
                {
                    text: 'Device',
                    value: 'real_device',
                    filterable: true,
                },
                {
                    text: 'Class',
                    value: 'real_class',
                    filterable: false,
                },
                {
                    text: 'Subclass',
                    value: 'real_subclass',
                    filterable: false,
                },
                {
                    text: 'Subsystem',
                    value: 'real_subsystem',
                    filterable: false,
                },
            ],
            systems: [{}],
            devices: [{}],
            allDevices: [{}],
            allSystems: [{}],
        }),
        mounted: function () {
            this.$http.get('https://www.pci-z.com/db/getSystems.php').then(response => {
                this.systems = response.body;
                this.dataSystemTablesLoading = false;
            }, response => {
                console.log(response);
                this.dataSystemTablesLoading = false;
            });
            this.$http.get('https://www.pci-z.com/db/getDevices.php').then(response => {
                this.allDevices = response.body;
                this.dataAllDevicesTablesLoading = false;
            }, response => {
                console.log(response);
                this.dataAllDevicesTablesLoading = false;
            });
        },
    }
</script>